import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mmb-web-app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
